export default "__VITE_PUBLIC_ASSET__ac3fb5d4__"